import React from 'react';

import { SVGComponentProps } from './svg.types';

const StopTimerSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M10 18.9583C5.63337 18.9583 2.08337 15.4083 2.08337 11.0417C2.08337 6.675 5.63337 3.125 10 3.125C14.3667 3.125 17.9167 6.675 17.9167 11.0417C17.9167 11.3833 17.6334 11.6667 17.2917 11.6667C16.95 11.6667 16.6667 11.3833 16.6667 11.0417C16.6667 7.36667 13.675 4.375 10 4.375C6.32504 4.375 3.33337 7.36667 3.33337 11.0417C3.33337 14.7167 6.32504 17.7083 10 17.7083C10.3417 17.7083 10.625 17.9917 10.625 18.3333C10.625 18.675 10.3417 18.9583 10 18.9583Z"
          fill={fill}
        />
        <path
          d="M10 11.4583C9.65833 11.4583 9.375 11.175 9.375 10.8333V6.66663C9.375 6.32496 9.65833 6.04163 10 6.04163C10.3417 6.04163 10.625 6.32496 10.625 6.66663V10.8333C10.625 11.175 10.3417 11.4583 10 11.4583Z"
          fill={fill}
        />
        <path
          d="M12.5 2.29163H7.5C7.15833 2.29163 6.875 2.00829 6.875 1.66663C6.875 1.32496 7.15833 1.04163 7.5 1.04163H12.5C12.8417 1.04163 13.125 1.32496 13.125 1.66663C13.125 2.00829 12.8417 2.29163 12.5 2.29163Z"
          fill={fill}
        />
        <path
          d="M15.8334 18.125C15.4917 18.125 15.2084 17.8416 15.2084 17.5V14.1666C15.2084 13.825 15.4917 13.5416 15.8334 13.5416C16.175 13.5416 16.4584 13.825 16.4584 14.1666V17.5C16.4584 17.8416 16.175 18.125 15.8334 18.125Z"
          fill={fill}
        />
        <path
          d="M13.3334 18.125C12.9917 18.125 12.7084 17.8416 12.7084 17.5V14.1666C12.7084 13.825 12.9917 13.5416 13.3334 13.5416C13.675 13.5416 13.9584 13.825 13.9584 14.1666V17.5C13.9584 17.8416 13.675 18.125 13.3334 18.125Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default StopTimerSVG;
